import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const FAQSection = () => {
  const { t } = useLanguage();

  const faqs = [
    { q: t("faq_q1"), a: t("faq_a1") },
    { q: t("faq_q2"), a: t("faq_a2") },
    { q: t("faq_q3"), a: t("faq_a3") },
    { q: t("faq_q4"), a: t("faq_a4") },
    { q: t("faq_q5"), a: t("faq_a5") },
    { q: t("faq_q6"), a: t("faq_a6") },
  ];

  return (
    <section id="faq" className="calli-section bg-gradient-to-b from-orange-50 to-white relative" data-testid="faq-section">
      <div className="calli-container relative z-10">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12 space-y-4">
            <span className="calli-badge">❓ {t("faq_badge")}</span>
            <h2 className="text-4xl md:text-5xl font-black text-gray-900">
              {t("faq_title")}
            </h2>
          </div>

          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm"
                data-testid={`faq-item-${index}`}
              >
                <AccordionTrigger className="px-6 py-5 hover:no-underline hover:bg-orange-50 transition-colors text-gray-900">
                  <span className="text-left font-semibold text-base">{faq.q}</span>
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-5">
                  <p className="text-gray-600 leading-relaxed">{faq.a}</p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
